(function(){
    'use strict';

    angular
    .module('app')
    .controller('Select2configController', Select2configController)
 
    Select2configController.$inject = ["FieldsService","$http","$timeout","$uibModal", "$log", "$document","$sce"];
        
    function Select2configController(FieldsService,$http,$timeout,$uibModal, $log, $document,$sce)
    {                       
        var vm = this;
        vm.json = "";
        vm.nodetype = "";
        vm.tags = [];
        vm.empty = "";
        vm.multiple = false;
        vm.relacionado = false;
        vm.field = "";
        vm.fieldorden = "";
        vm.camporelacionado = "";
        vm.condiciones = [];
        vm.relacionadocampocheck = "";
        vm.update = function(){
            var j = JSON.parse($('#fieldconfig-value').val());


            j.references["nodeType"] = vm.nodetype;
            j.references["field"] = vm.field;
            j.references["fieldorden"] = vm.fieldorden;
            j.references["valuedefault"] = vm.valuedefault;
            j.references["relacionadocampocheck"] = vm.relacionadocampocheck;
            j.references["camporelacionado"] = vm.camporelacionado;
            j.references["multiple"] = vm.multiple;
            j.references["tags"] = vm.tags;
            j.references["relacionado"] = vm.relacionado;
            j.references["condiciones"] = vm.condiciones;
            j.references["empty"] = vm.empty;

            console.log(vm.condiciones);
			vm.scopeParent.$parent.fieldsVm.jsonValue = angular.toJson(j);
			$('#fieldconfig-value').val(vm.scopeParent.$parent.fieldsVm.jsonValue);
        };

        vm.init = function(scopeParent){
            $timeout(function(){
                FieldsService.getFieldsByNode(vm.nodetype,false,function(data){
                  vm.fields = data.fields;
                });
            });    
        	vm.scopeParent = scopeParent;
        	console.log(scopeParent);
        	var valorJson = $('#fieldconfig-value').val();
        	if(valorJson!=""){
        		vm.json = JSON.parse(valorJson);
                if(typeof vm.json.references.tags!='undefined'){
                    vm.tags = vm.json.references.tags;
                }
                if(typeof vm.json.references.condiciones!='undefined'){
                    vm.condiciones = vm.json.references.condiciones;
                    //console.log(vm.json);
                }
                if(typeof vm.json.references.relacionado!='undefined'){
                    vm.relacionado = vm.json.references.relacionado;
                }
                if(typeof vm.json.references.relacionadocampocheck!='undefined'){
                    vm.relacionadocampocheck = vm.json.references.relacionadocampocheck;
                }
                if(typeof vm.json.references.multiple!='undefined'){
                    vm.multiple = vm.json.references.multiple;
                }
                if(typeof vm.json.references.multiple!='undefined'){
                    vm.fieldorden = vm.json.references.fieldorden;
                }
        	}
        	vm.update();
        };

        vm.borrarTag = function(index){
            vm.tags.splice(index,1);
            vm.update();
        };

        vm.addTag = function(){
            if(typeof vm.tags=='undefined'){
                vm.tags = [];
            }
            vm.tags[vm.tags.length] = "";
            vm.update();
        };

    } 

})();